module.exports = __webpack_public_path__ + "static/img/img05.dfb0758.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img05.png
// module id = 4m/J
// module chunks = 1